import { render, staticRenderFns } from "./DashboardGreeting.vue?vue&type=template&id=bb151306&scoped=true"
import script from "./DashboardGreeting.vue?vue&type=script&lang=js"
export * from "./DashboardGreeting.vue?vue&type=script&lang=js"
import style0 from "./DashboardGreeting.vue?vue&type=style&index=0&id=bb151306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb151306",
  null
  
)

export default component.exports